
<script>
import {mapGetters, mapState} from 'vuex';

export default {
  name: 'update-mobile-app-dialog',
  computed: {
    ...mapState('dialogs', {
      visible: ({dialogs}) => dialogs['update-mobile-app'].visible,
    }),
    ...mapGetters('auth', [
      'LOCALE',
    ]),
  }
}
</script>

<template>
	<el-dialog
		v-if="visible"
		v-model="visible"
		:close-on-click-modal="false"
		:fullscreen="true"
		:show-close="false"
		center
		custom-class="update-app-dialog"
		destroy-on-close
		lock-scroll
	>
		<template #header>
			<div class="update-app-dialog__logo">
				<span class="logo">{{ $t('header.title') }}</span>
				<span v-t="'header.subtitle'" class="subtitle" />
			</div>
		</template>
		<div class="update-app-dialog__title">
			{{ $t('update_app.title') }}
		</div>
		<div class="update-app-dialog__text">{{ $t('update_app.text') }}</div>
		<div class="update-app-dialog__text">
			{{ $t('update_app.button_text') }}
		</div>
		<div
			class="mt-4 d-flex justify-content-center align-items-center flex-column"
		>
			<img class="promo-man" src="@/assets/images/landing/promoman.svg" />
			<a
				v-if="webview === 'ios'"
				href="https://promojagers.short.gy/promojagers-ios"
				target="_blank"
			>
				<img
					v-if="LOCALE === 'nl'"
					alt="App Store Logo"
					class="app-store"
					loading="lazy"
					src="@/assets/images/app/app-store-nl.svg"
				/>
				<img
					v-else
					alt="App Store Logo"
					class="app-store"
					loading="lazy"
					src="@/assets/images/app/app-store-fr.svg"
				/>
			</a>
			<a v-else href="https://promojagers.short.gy/promojagers-android" target="_blank">
				<img
					v-if="LOCALE === 'nl'"
					alt="Play Store Logo"
					class="google-play"
					loading="lazy"
					src="@/assets/images/app/google-play-nl.png"
				/>
				<img
					v-else
					alt="Play Store Logo"
					class="google-play"
					loading="lazy"
					src="@/assets/images/app/google-play-fr.png"
				/>
			</a>
		</div>
	</el-dialog>
</template>
